import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import ScrollToTop from "./components/ScrollToTop"; // ✅ ADD THIS
import LeaveReview from './pages/LeaveReview';
import ReviewsPage from "./pages/ReviewsPage";


// Pages
import HomePage from "./pages/HomePage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import StaffDashboard from "./pages/StaffDashboard";
import AboutPage from "./pages/AboutPage";
import PaymentDetails from "./pages/Payment";


// Tour Components
import TourDetail from "./components/tours/TourDetail";
import TourListPage from "./components/tours/TourListPage";

function App() {
  return (
    <AppProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop /> {/* ✅ ADD THIS LINE */}

          <Routes>
            <Route path="/" element={<HomePage />} />

            <Route
              path="/trekking"
              element={<TourListPage category="trekking" title="Trekking Adventures" />}
            />
            <Route
              path="/mountain-biking"
              element={<TourListPage category="mountain-biking" title="Mountain Biking" />}
            />
            <Route
              path="/ski-tours"
              element={<TourListPage category="ski-tours" title="Ski Tours" />}
            />
            <Route
              path="/culture-tours"
              element={<TourListPage category="culture-tours" title="Culture Tours" />}
            />
            <Route
              path="/nature-treat-hut"
              element={<TourListPage category="nature-treat-hut" title="Nature Treat Hut" />}
            />
            <Route
              path="/cycling-tours"
              element={<TourListPage category="cycling-tours" title="Cycling Tours" />}
            />
            <Route path="/leave-review" element={<LeaveReview />} />
            <Route path="/tour/:id" element={<TourDetail />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/staff" element={<StaffDashboard />} />
            <Route path="/payment" element={<PaymentDetails />} />
            <Route path="/reviews" element={<ReviewsPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AppProvider>
  );
}

export default App;
